// extracted by mini-css-extract-plugin
module.exports = {"parallaxChild":"parallaxChildStyles-module--parallaxChild--25alK"};